import axios from '../../../http';

function initialState () {
  return {
    mprnNumber: null,
    mpanValid: null,
    mpanNumber: null,
    switchAfterCoolingOfPeriod: null,
    gasSmartMeterInstalled: false,
    electricitySmartMeterInstalled: false,
    neitherSmartMeterInstalled: false,
    agreeSmartMeterConditions: false,
    suppliersTermsAndConditionsAreAccepted: null,
    hasMedicalConditionOrIndividualRequirement: false,
    gasSmartMeterInstalled: false,
    specialNeedsId: null,
    happyToReceiveCreditCheck: false,
    happyToHaveDebtInformationAccessed: false,
    supplierMaySendRemindersAndUpdatesViaEmailAboutAccount: false,
    supplierMaySendImportantAccountChangesViaEmail: false,
    supplierMaySendRemindersAndUpdatesViaTelephoneAboutAccount: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaDayPhone: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaEmail: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaEveningPhone: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaFaceToFace: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaPost: false,
    supplierMaySendUpdatesThatMayBeOfInterestViaSms: false,
    prePaymentMeterId: null
  };
}

const state = initialState();

const getters = {};

const actions = {
  async update ({ state, rootState, commit }) {
    const { switchKey } = rootState.storage;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/update/terms-and-conditions',
        data: { switchKey, ...state }
      });

      if (status != 200) {
        throw 'terms';
      }
    } catch (error) {
      throw 'terms';
    }
  }
};

const mutations = {
  updateState (state, value) {
    state = Object.assign(state, value);
  },
  resetState (state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
